import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {

  constructor() {
    console.log('UnauthorizedComponent initialized');
   }

  ngOnInit(): void {
    console.log('UnauthorizedComponent ngOnInit');
  }

}
